import classNames from 'classnames';
import * as classes from './Heading.css';
import { ComponentProps } from 'react';
import BaseTypography from '../BaseTypography';

export interface HeadingProps {
  id?: string;
  'data-test-id'?: string;
  /**
   * Define the content of the Heading.
   * @type string
   * @required
   */
  children?: string;
  /**
   * Define the content of the Heading.
   * @type string
   * @required
   */
  text?: string;
  /**
   * Define the color of the Heading.
   * @type ComponentProps<typeof BaseTypography>['color']
   * @optional
   */
  color?: ComponentProps<typeof BaseTypography>['color'];
  /**
   * Define the custom className.
   * @type string
   * @optional
   */
  className?: string;
  /**
   * Define the font size of the Heading.
   * @type 's' | 'm' | 'l' | 'xl'
   * @required
   */
  size: 's' | 'm' | 'l' | 'xl' ;
  /**
   * Define the font style of the Heading.
   * @type string
   * @optional
   */
  fontStyle?: string;
  /**
   * Define the component type.
   * @type "h1" | "h2" | "h3" | "h4" | "h5" | "h6"
   * @optional
   */
  component?: keyof Pick<React.JSX.IntrinsicElements, 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'>;
  /**
   * Define the component type.
   * @type "h1" | "h2" | "h3" | "h4" | "h5" | "h6"
   * @optional
   */
  variant?: keyof Pick<React.JSX.IntrinsicElements, 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'>;
  /**
   * Define the title of the Heading.
   * @type string
   * @optional
   */
  title?: string;
  /**
   * Hide Heading Component.
   * @type string
   * @optional
   */
  hide?: boolean;
  /**
   * Define the horizontal alignment of the Heading.
   * @type "left" | "center" | "right"
   * @optional
   */
  hAlignContent?: 'left' | 'center' | 'right';
  /**
   * Enable animation triggered whe the element is visible.
   * @type boolean
   * @optional
   */
  animated?: boolean;
  /**
   * The animation type triggered whe the element is visible. Default is fadeIn
   * @type string
   * @optional
   */
  animation?: string;
  /**
   * The animation type triggered whe the element is visible. Default is fadeIn
   * @type string
   * @optional
   */
  animationType?: string;
}

export function Heading(props: HeadingProps) {
  // console.log("Component Heading ===== ", props?.variant)
  return (
    <>
      {!props?.hide && <BaseTypography
        data-test-id={props['data-test-id']}
        title={props.title}
        role="heading"
        aria-level="2"
        // component={(props.component || props.variant) ?? 'span'}
        component={["span", "p", "label", "h4", "h5", "h1", "h2", "h3", "h6"].includes(props.component || "") ? props.component || "span" : 'span'}
        hAlignContent={props.hAlignContent}
        color={props.color}
        style={{
          fontFamily: !props?.fontStyle ? 'notoIkea, sans-serif' : props?.fontStyle === "default" ? 'notoIkea, sans-serif' : `${props?.fontStyle}, sans-serif`,
        }}
        className={classNames(
          classes.variant[props.size], 
          props.className
        )}
        animated={props.animated ?? false}
        animation={(props.animation || props.animationType) ?? ''}
        id={props.id}
      >
        {props.text || props.children}
      </BaseTypography>}
    </>
  );
}


// Tailwind Font approach -- (avoid)
        // {
        //   [`font-${classes.base}`] : props?.fontStyle === "heading",
        //   [`font-${props?.fontStyle}`]: props?.fontStyle !== "heading"
        // },
        // props?.fontStyle ? `font-${props?.fontStyle}` : `font-heading`,
        // `font-${props?.fontStyle}`,
        // `font-${props?.fontStyle === "heading" ? classes.base : props?.fontStyle}`, 
        // `font-${props?.fontStyle ? props?.fontStyle : classes.base}`, 
